module.exports = __webpack_public_path__ + "img/list-pattern2.4a3dc5c.svg";